/* eslint-disable no-unused-vars */
import gql from 'graphql-tag';

export const SYMBOL_BY_USER = gql`
  query SYMBOLPANEL($id: uuid) {
    core_user(where: { id: { _eq: $id } }) {
      id
      user_symbols {
        symbol {
          symbolcode
          id: symbolid
          name: symbolname
          forecast_horizon_list: daily_returns(distinct_on: forecast_horizon) {
            forecast_horizon
          }
        }
      }
    }
  }
`;

export const SYMBOL_BY_USER_WITH_STATUS = gql`
  subscription {
    core_user {
      azure_id
      user_symbols(where: { status: { _neq: "canceled" } }) {
        symbol {
          symbolcode
          id: symbolid
          name: symbolname
          forecast_horizon_list: daily_returns(distinct_on: forecast_horizon) {
            forecast_horizon
          }
          stripe_product_id
          models {
            forecast_horizon
            unit {
              unitname
            }
            id
            name
          }
          symbol_description {
            description
          }
          web_product_symbol_mappings {
            product {
              product_name
            }
          }
        }
        expiry_date
        interval
        invoice_status
        status
      }
    }
  }
`;

export const NEWS_BY_SYMBOLS = gql`
  subscription NewsQuery($symbolId: Int) {
    core_news(
      where: { news_symbol_to_symbol: { symbol: { symbolid: { _eq: $symbolId } } } }
      order_by: { date: desc }
    ) {
      id
      date
      title
      description
      notification_read {
        read
      }
      text_analysis {
        analysis
        analysis_type
        created_on
      }
    }
  }
`;

export const HISTORICAL_FORECAST_RETURN = gql`
  subscription historicalForecastReturn($symbolId: Int, $forecastHorizon: String) {
    core_daily_returns(
      where: {
        symbol_id: { _eq: $symbolId }
        fund_type: { _nlike: "%Market Returns%" }
        forecast_horizon: { _eq: $forecastHorizon }
      }
      order_by: { date: desc }
      limit: 10
    ) {
      date
      currency_return
      percentage_return
      fund_type
      symbol_id
      forecast_horizon
    }
  }
`;

export const HISTORICAL_FORECAST_RETURN_WITH_MODEL_ID = gql`
  subscription historicalForecastReturn($symbolId: Int, $forecastHorizon: String, $modelId: Int) {
    core_daily_returns(
      where: {
        symbol_id: { _eq: $symbolId }
        fund_type: { _nlike: "%Market Returns%" }
        forecast_horizon: { _eq: $forecastHorizon }
        model_id: { _eq: $modelId }
      }
      order_by: { date: desc }
      limit: 10
    ) {
      date
      currency_return
      percentage_return
      fund_type
      symbol_id
      forecast_horizon
    }
  }
`;

export const SINGLE_RECENT_FORECAST = gql`
  subscription singleRecentForecast($symbolCode: String, $forecastHorizon: String) {
    core_trading_history(
      where: {
        symbol: { _eq: $symbolCode }
        forecast_horizon: { _eq: $forecastHorizon }
        username: { _neq: "audit" }
        model_id: { _eq: $modelId }
      }
      order_by: { trade_id: desc }
      limit: 1
    ) {
      trading_history_lineages {
        date_applicable_for
        action_item
        prediction
        target_price
        description
      }
    }
  }
`;

export const SINGLE_RECENT_FORECAST_WITH_MODEL_ID = gql`
  subscription singleRecentForecast($symbolCode: String, $forecastHorizon: String, $modelId: Int) {
    core_trading_history(
      where: {
        symbol: { _eq: $symbolCode }
        forecast_horizon: { _eq: $forecastHorizon }
        username: { _neq: "audit" }
        model_id: { _eq: $modelId }
      }
      order_by: { trade_id: desc }
      limit: 1
    ) {
      trading_history_lineages {
        date_applicable_for
        action_item
        prediction
        target_price
        description
      }
    }
  }
`;

export const SINGLE_RECENT_FORECAST_2 = gql`
  subscription singleRecentForecastDirectionPrice($symbolCode: String, $forecastHorizon: String, $modelId: Int!) {
    core_trading_history(
      where: {
        symbol: { _eq: $symbolCode }
        forecast_horizon: { _eq: $forecastHorizon }
        username: { _neq: "audit" }
        model_id: { _eq: $modelId }
      }
      order_by: { trade_id: desc }
      limit: 1
    ) {
      trading_history_lineages {
        date_applicable_for
        action_item
        prediction
        target_price
        description
      }
    }
  }
`;

export const SINGLE_RECENT_FORECAST_2_WITH_MODEL_ID = gql`
  subscription singleRecentForecast($symbolCode: String, $forecastHorizon: String, $modelId: Int) {
    core_trading_history(
      where: {
        symbol: { _eq: $symbolCode }
        forecast_horizon: { _eq: $forecastHorizon }
        username: { _neq: "audit" }
        model_id: { _eq: $modelId }
      }
      order_by: { trade_id: desc }
      limit: 1
    ) {
      trading_history_lineages {
        date_applicable_for
        action_item
        prediction
        target_price
        description
      }
    }
  }
`;

export const MARKER_OVERVIEW_GRAPH_DATA = gql`
  query marketOverviewGraphData($symbolCode: String, $startDate: date, $endDate: date) {
    core_historical(where: { symbolcode: { _eq: $symbolCode }, date: { _gte: $startDate, _lte: $endDate } }) {
      date
      close
    }
  }
`;

export const HISTORICAL_PRICE_DATA = gql`
  query historicalPriceData($symbolCode: String) {
    core_historical(
      where: { symbolcode: { _eq: $symbolCode }, date: { _gte: "2015-01-01" } }
      order_by: { date: asc }
    ) {
      close
      date
    }
  }
`;

export const HISTORICAL_PRICE_CUMMULATIVE_DATA = gql`
  query historicalPriceCummulativeData($symbolCode: String, $forecastHorizon: String) {
    core_price_returns_view(
      where: { forecast_horizon: { _eq: $forecastHorizon }, symbolcode: { _eq: $symbolCode } }
      order_by: { date: asc }
    ) {
      close
      cumulative_returns
      date
      fund_type
      open
      symbol_id
      symbolcode
      forecast_horizon
    }
  }
`;

export const HISTORICAL_PRICE_CUMMULATIVE_DATA_WITH_MODEL_ID = gql`
  query historicalPriceCummulativeData($symbolCode: String, $forecastHorizon: String, $modelId: Int) {
    core_price_returns_view(
      where: {
        forecast_horizon: { _eq: $forecastHorizon }
        symbolcode: { _eq: $symbolCode }
        model_id: { _eq: $modelId }
      }
      order_by: { date: asc }
    ) {
      close
      cumulative_returns
      date
      fund_type
      open
      symbol_id
      symbolcode
      forecast_horizon
    }
  }
`;

export const HISTORICAL_PRICE_CUMMULATIVE_DATA_DIRECTION_PRICE = gql`
  query MyQuery($symbolCode: String) {
    core_web_market_close_forecast(where: { symbolcode: { _eq: $symbolCode } }) {
      close
      date
      forecast_direction
      forecast_price
      model_symbolcode
    }
  }
`;

export const HISTORICAL_PRICE_CUMMULATIVE_DATA_DIRECTION_PRICE_MODEL_ID = gql`
  query MyQuery($symbolCode: String, $modelId: String) {
    core_web_market_close_forecast(
      where: { symbolcode: { _eq: $symbolCode }, model_id: { _eq: $modelId } }
      order_by: { date: asc }
    ) {
      close
      date
      forecast_direction
      forecast_price
      model_symbolcode
    }
  }
`;

export const YEARLY_STATISTICS_CARD = gql`
  query yearlyStatisticsCard($symbolCode: String, $forecastHorizon: String, $ratioType: String) {
    core_year_overview(
      where: {
        symbol: { symbolcode: { _eq: $symbolCode } }
        forecast_horizon: { _eq: $forecastHorizon }
        metric: { _eq: $ratioType }
      }
    ) {
      fund_type
      metric
      value
      year
    }
  }
`;

export const HISTORICAL_FORECAST_DATA = gql`
  query historicalForecastData($symbolCode: String, $forecastHorizon: String) {
    core_historical_forecast_returns_view(
      where: { symbol: { _eq: $symbolCode }, forecast_horizon: { _eq: $forecastHorizon } }
      limit: 300
    ) {
      prediction
      liqural_return
      market_return
      forecast_horizon
      date
    }
  }
`;

export const HISTORICAL_FORECAST_DIRECTION_PRICE_DATA = gql`
  query historicalForecastData($symbolCode: String, $forecastHorizon: String) {
    core_historical_forecast_absolute_returns_view(
      where: { symbol: { _eq: $symbolCode }, forecast_horizon: { _eq: $forecastHorizon } }
      limit: 300
    ) {
      prediction
      liqural_return
      market_return
      forecast_horizon
      date
    }
  }
`;

export const SUBSCRIPTION_PLAN_DETAILS = gql`
  query subscriptionPlanDetails {
    core_product_plan(order_by: { monthly_price: desc }) {
      detail
      monthly_price
      name
      yearly_price
    }
  }
`;

export const SUBSCRIPTION_PLAN_DETAILS_WITH_EXPERIMENT = gql`
  query subscriptionPlanDetailsWithExperiment($price_plan_name: String) {
    core_product_plan(where: { price_plan_name: { _eq: $price_plan_name } }) {
      detail
      monthly_price
      name
      price_plan_name
      yearly_price
      serial_number
    }
  }
`;

export const PAYMENT_PROCESSING = gql`
  subscription MyQuery {
    core_user_aggregate {
      nodes {
        user_symbols_aggregate(where: { status: { _nin: ["canceled", "incomplete_expired"] } }) {
          aggregate {
            count
          }
        }
      }
    }
  }
`;

export const GET_STRIPE_ID = gql`
  query MyQuery {
    core_user {
      stripe_id
    }
  }
`;

export const MARKET_OVERVIEW_CARDS_DATA = gql`
  query marketOverviewCardsData($symbolCode: String) {
    core_web_market_overview(where: { symbolcode: { _eq: $symbolCode } }) {
      symbolcode
      market_overview
      updated_at
    }
  }
`;

export const REPORT_DATA_ANALYSIS = gql`
  subscription reportDataAnalysis {
    core_web_data_analysis_tracking(order_by: { created_at: desc }) {
      data_analysis_status
      comment
      report_name
      data_validation_status
      file_status
      user_id
      file_name
      file_path
      created_at
      updated_at
      uuid
      web_data_analysis_reports(limit: 1) {
        report_layout_version
      }
    }
  }
`;

export const USER_SPECIFIC_ALL_REPORTS_DATA = gql`
  query userSpecificAllReportsData($uuid: uuid) {
    core_web_data_analysis_report(where: { uuid: { _eq: $uuid } }) {
      chart_payload
      index
      user_id
      uuid
    }
  }
`;

export const USER_SPECIFIC_REPORTS_DATA = gql`
  query userSpecificReportsData($uuid: uuid, $chart_position: jsonb) {
    core_web_data_analysis_report(where: { uuid: { _eq: $uuid }, chart_payload: { _contains: $chart_position } }) {
      chart_payload
      index
      user_id
      uuid
    }
  }
`;

export const USER_SPECIFIC_REPORTS_DATA_UPDATED = gql`
  query userSpecificReportsDataUpdated($file_uuid: uuid, $section: String, $chart_position: jsonb) {
    core_web_data_analysis_report(
      where: {
        uuid: { _eq: $file_uuid }
        page_section: { _eq: $section }
        chart_payload: { _contains: $chart_position }
      }
    ) {
      chart_payload
      chart_position
      page_section
      report_layout_version
      uuid
    }
  }
`;

export const USER_SPECIFIC_ALL_REPORTS_COUNT = gql`
  query userSpecificAllReportsCount($uuid: uuid) {
    core_web_data_analysis_report_aggregate(where: { uuid: { _eq: $uuid } }) {
      aggregate {
        count
      }
    }
  }
`;

export const USER_SPECIFIC_ALL_REPORTS_COUNT_UPDATED = gql`
  query userSpecificAllReportsCountUpdated($section: String, $report_uuid: uuid) {
    core_web_data_analysis_report_aggregate(where: { page_section: { _eq: $section }, uuid: { _eq: $report_uuid } }) {
      aggregate {
        count
      }
    }
  }
`;

export const CALLBACK_AFTER_FILE_UPLOAD = gql`
  mutation callbackAfterFileUpload($uuid: uuid, $azure_id: String, $filename: String, $report_name: String) {
    insert_core_web_data_analysis_tracking_one(
      object: {
        file_name: $filename
        data_analysis_status: "pending"
        data_validation_status: "pending"
        file_path: "web/"
        file_status: "uploaded"
        user_id: $azure_id
        uuid: $uuid
        report_name: $report_name
      }
    ) {
      data_analysis_status
      comment
      data_validation_status
      file_name
      file_path
      file_status
      updated_at
      created_at
      user_id
      uuid
    }
  }
`;

export const GRAPH_SECTION_DESCRIPTION = gql`
  query graphSectionDescription($version: String) {
    core_web_daas_section_description(where: { report_layout_version: { _eq: $version } }) {
      description
      page_section
      report_layout_version
    }
  }
`;

export const LIQURAL_PERFORMANCE_RETURN = gql`
  query liquralPerformanceReturn($date_from: date, $symbol_code: String, $forecast_horizon: String, $modelId: Int) {
    core_daily_returns_aggregate(
      where: {
        symbol: { symbolcode: { _eq: $symbol_code } }
        forecast_horizon: { _eq: $forecast_horizon }
        date: { _gte: $date_from }
        fund_type: { _nilike: "Market Returns%" }
        model_id: { _eq: $modelId }
      }
    ) {
      aggregate {
        sum {
          percentage_return
          currency_return
        }
      }
    }
  }
`;

export const MARKET_PERFORMANCE_RETURN = gql`
  query marketPerformanceReturn($date_from: date, $symbol_code: String, $forecast_horizon: String, $modelId: Int) {
    core_daily_returns_aggregate(
      where: {
        symbol: { symbolcode: { _eq: $symbol_code } }
        forecast_horizon: { _eq: $forecast_horizon }
        date: { _gte: $date_from }
        fund_type: { _ilike: "Market Returns%" }
        model_id: { _eq: $modelId }
      }
    ) {
      aggregate {
        sum {
          percentage_return
          currency_return
        }
      }
    }
  }
`;

export const MARKET_DAILY_RETURN = gql`
  query marketDailyReturn($date_from: date, $forecast_horizon: String, $symbol_code: String, $modelId: Int) {
    core_daily_returns(
      where: {
        symbol: { symbolcode: { _eq: $symbol_code } }
        date: { _gte: $date_from }
        forecast_horizon: { _eq: $forecast_horizon }
        fund_type: { _ilike: "Market Returns%" }
        model_id: { _eq: $modelId }
      }
    ) {
      date
      percentage_return
      currency_return
      symbol {
        symbolname
        symbolcode
      }
      fund_type
      forecast_horizon
    }
  }
`;

export const LIQURAL_DAILY_RETURN = gql`
  query liquralDailyReturn($date_from: date, $forecast_horizon: String, $symbol_code: String, $modelId: Int) {
    core_daily_returns(
      where: {
        symbol: { symbolcode: { _eq: $symbol_code } }
        date: { _gte: $date_from }
        forecast_horizon: { _eq: $forecast_horizon }
        fund_type: { _nilike: "Market Returns%" }
        model_id: { _eq: $modelId }
      }
    ) {
      date
      percentage_return
      currency_return
      symbol {
        symbolname
        symbolcode
      }
      fund_type
      forecast_horizon
    }
  }
`;

export const GLOBAL_ECONOMIES_DATA = gql`
  query globalEconomiesData {
    core_web_market_analysis(where: { type: { _eq: "country" } }) {
      data_detail
      date
      name
      outlook
      type
    }
  }
`;

export const NOTIFICATION_QUERY = gql`
  subscription notificationQuery($symbol_code: String!) {
    core_web_notifications(
      order_by: { date: desc }
      where: { symbol_code: { _in: [$symbol_code, "Oil"] }, category: { _neq: "Analyst Note" } }
    ) {
      category
      date
      title
      payload
      symbol_code
      uuid
      analysis_notification {
        read
      }
    }
  }
`;

export const NOTIFICATION_QUERY_2 = gql`
  subscription notificationQuery($symbol_code: String!) {
    core_web_notifications(
      order_by: { date: desc }
      where: { symbol_code: { _in: [$symbol_code, "Oil"] }, category: { _eq: "Analyst Note" } }
    ) {
      category
      date
      title
      payload
      symbol_code
    }
  }
`;

// DAAS Version 2 Query

export const ANALYSIS_COLUMN_SELECTOR = gql`
  query analysisColumnSelector($report_uuid: uuid) {
    core_web_data_analysis_report(
      where: { uuid: { _eq: $report_uuid }, page_section: { _eq: "analysis column selector" } }
    ) {
      chart_position
      page_section
      chart_payload(path: "columns")
      user_id
      uuid
      index
    }
  }
`;

export const DAAS_V2_CHART_DATA = gql`
  query daasV2ChartData($jsonFilter: jsonb, $report_uuid: uuid) {
    core_web_data_analysis_report(
      where: {
        uuid: { _eq: $report_uuid }
        page_section: { _in: ["correlation_analysis", "overview", "seasonality_analysis", "distribution_correlation"] }
        chart_payload: { _contains: $jsonFilter }
      }
    ) {
      chart_position
      page_section
      user_id
      uuid
      index
      chart_payload
      report_layout_version
    }
  }
`;

export const FAQ_DATA = gql`
  query faqData {
    core_web_faq {
      body
      heading
      id
      topic
    }
  }
`;

// New Main Page Queries

export const SINGLE_RECENT_FORECAST_FOR_CARD = gql`
  subscription singleRecentForecastForCard($symbolCode: String, $forecastHorizon: String, $modelId: Int!) {
    core_trading_history(
      where: {
        symbol: { _eq: $symbolCode }
        forecast_horizon: { _eq: $forecastHorizon }
        username: { _neq: "audit" }
        model_id: { _eq: $modelId }
      }
      order_by: { trade_id: desc }
      limit: 1
    ) {
      trading_history_lineages {
        date_applicable_for
        action_item
        prediction
        description
      }
    }
  }
`;

export const SINGLE_RECENT_FORECAST_FOR_CARD_PRICE_DIRECTION = gql`
  subscription singleRecentForecastForCardPriceDirection(
    $symbolCode: String
    $forecastHorizon: String
    $modelId: Int!
  ) {
    core_trading_history(
      where: {
        symbol: { _eq: $symbolCode }
        forecast_horizon: { _eq: $forecastHorizon }
        username: { _neq: "audit" }
        model_id: { _eq: $modelId }
      }
      order_by: { trade_id: desc }
      limit: 1
    ) {
      trading_history_lineages {
        date_applicable_for
        action_item
        prediction
        target_price
        description
      }
    }
  }
`;

export const MARKET_OVERVIEW_SINGLE_FOR_CARD = gql`
  query marketOverviewSingleForCard($symbolCode: String) {
    core_web_market_overview(where: { symbolcode: { _eq: $symbolCode } }) {
      symbolcode
      market_overview
      updated_at
    }
  }
`;

export const HISTORICAL_FORECAST_FOR_CARD = gql`
  query historicalForecastForCard($symbolId: Int, $modelId: Int) {
    core_web_forecast_comparison_view(
      where: { symbol_id: { _eq: $symbolId }, model_id: { _eq: $modelId } }
      order_by: { date: desc }
      limit: 50
    ) {
      date
      forecast_horizon
      symbol_id
      liqural_currency_return
      market_currency_return
      liqural_percentage_return
      market_percentage_return
      model_id
    }
  }
`;

export const MARKET_RELATION_FOR_CARD = gql`
  query marketRelationForCard($symbolCode: String!) {
    core_web_notifications(order_by: { date: desc }, limit: 1, where: { symbol_code: { _in: [$symbolCode, "Oil"] } }) {
      symbol_code
      date
      payload
      title
    }
  }
`;

// Direction Price Query
export const HISTORICAL_DIRECTION_PRICE_FORECAST_FOR_CARD = gql`
  query historicalForecastForCard($symbolId: Int, $modelId: Int) {
    core_web_forecast_comparison_view(
      where: { symbol_id: { _eq: $symbolId }, model_id: { _eq: $modelId } }
      order_by: { date: desc }
      limit: 50
    ) {
      date
      forecast_horizon
      symbol_id
      liqural_currency_return
      market_currency_return
      model_id
    }
  }
`;

// Get Experiment Query
export const GET_USERS_EXPERIMENT = gql`
  query userExperiments {
    core_web_experiments(where: { experiment_status: { _eq: "in-progress" } }) {
      experiment_config
      web_section
      __typename
      experiment_status
    }
  }
`;

// Combined Forecast Performance Table Query
export const COMBINED_FORECAST_PERFORMANCE_TABLE_QUERY = gql`
  query combinedForecastPerformanceTableQuery($symbol_code: String) {
    core_web_forecast_performance_table(where: { symbolcode: { _eq: $symbol_code } }) {
      date
      prediction
      liqural_currency_return
      liqural_percentage_return
      market_currency_return
      market_percentage_return
      target_price
    }
  }
`;

export const COMBINED_FORECAST_PERFORMANCE_TABLE_QUERY_WITH_MODEL_ID = gql`
  query combinedForecastPerformanceTableQuery($symbol_code: String, $modelId: Int) {
    core_web_forecast_performance_table(where: { symbolcode: { _eq: $symbol_code }, model_id: { _eq: $modelId } }) {
      date
      prediction
      liqural_currency_return
      liqural_percentage_return
      market_currency_return
      market_percentage_return
      target_price
    }
  }
`;

// Forecast Overview Single Query
export const FORECAST_OVERVIEW_COMBINED_QUERY = gql`
  query forecastOverviewCombinedQuery($symbol_code: String) {
    core_web_forecast_performance_table(
      where: { symbolcode: { _eq: $symbol_code } }
      limit: 1
      order_by: { date: desc }
    ) {
      date
      prediction
      liqural_currency_return
      liqural_percentage_return
      market_currency_return
      market_percentage_return
      target_price
    }
  }
`;

export const FORECAST_OVERVIEW_COMBINED_QUERY_WITH_MODEL_ID = gql`
  query forecastOverviewCombinedQuery($symbol_code: String, $modelId: Int) {
    core_web_forecast_performance_table(
      where: { symbolcode: { _eq: $symbol_code }, model_id: { _eq: $modelId } }
      limit: 1
      order_by: { date: desc }
    ) {
      date
      prediction
      liqural_currency_return
      liqural_percentage_return
      market_currency_return
      market_percentage_return
      target_price
    }
  }
`;

// Product Level Segmentation
export const PRODUCT_SEGMENTATION = gql`
  query productSegmentation {
    core_web_user_productsymbol_view_aggregate(distinct_on: product_name) {
      nodes {
        product_name
      }
    }
  }
`;

// Product Based Symbol
export const PRODUCT_BASED_SYMBOL = gql`
  query productBasedSymbol($product_name: String) {
    core_web_user_productsymbol_view(where: { product_name: { _eq: $product_name } }) {
      product_name
      symbol_id
    }
  }
`;

export const GET_AVAILABLE_WORKSPACE = gql`
  query getAvailableWorkspace($product_name: String) {
    core_web_product_indicator(
      where: { product: { product_name: { _eq: $product_name } } }
      distinct_on: indicator_name
    ) {
      indicator_name
    }
  }
`;

export const GET_COUNTRY_BASED_ON_INDICATOR = gql`
  query getCountryBasedOnIndicator($product_name: String, $indicator_name: String) {
    core_web_product_indicator(
      where: { product: { product_name: { _eq: $product_name } }, indicator_name: { _eq: $indicator_name } }
      distinct_on: indicator_country
    ) {
      indicator_country
    }
  }
`;

export const MARK_NOTIFICATION_READ_STATUS = gql`
  mutation markNotificationReadStatus($id: String!) {
    insert_core_web_newsanalysis_notification_one(
      object: { id: $id }
      on_conflict: { constraint: web_newsanalysis_notification_id_user_id_key }
    ) {
      id
      read
      user_id
    }
  }
`;

export const DATA_DASHBOARD_PRODUCTION = gql`
  query dataDashboardProduction($country: String) {
    core_datadashboard_production(where: { country: { _eq: $country } }, order_by: { date: asc }) {
      date
      unit
      value
    }
  }
`;

export const DATA_DASHBOARD_COUNTRY = gql`
  query dataDashboardCountry {
    core_datadashboard_production(distinct_on: country) {
      country
    }
  }
`;

export const DATA_DASHBOARD_HISTORICAL_PRICE_DATA = gql`
  query dataDashboardHistoricalPriceData($symbolCode: String!) {
    core_historical(where: { symbolcode: { _eq: $symbolCode } }, order_by: { date: asc }) {
      date
      close
    }
  }
`;

// AI Assistant Related API

export const STARTING_CHAT_CONVERSATION = gql`
  mutation startingChatConversation($chat_id: String, $input: String) {
    insert_core_web_chat(objects: { chat_id: $chat_id, input: $input }) {
      returning {
        sub_chat_id
      }
    }
  }
`;

export const GET_CHAT_DATA = gql`
  subscription getChatData {
    core_web_chat(order_by: { timestamp: asc }) {
      input
      response
      timestamp
    }
  }
`;

/* Data Dashboard Import Export Queries */

export const GET_EXPORT_COUNTRIES = gql`
  query getExportCountries {
    core_datadashboard_export(distinct_on: country) {
      country
    }
  }
`;

export const GET_DATADASHBOARD_EXPORT_DATA = gql`
  query getDatadashboardExportData($countries: [String!]) {
    core_datadashboard_export(where: { country: { _in: $countries } }) {
      country
      data_source
      date
      unit
      value
    }
  }
`;

export const GET_IMPORT_COUNTRIES = gql`
  query getExportCountries {
    core_datadashboard_import(distinct_on: country) {
      country
    }
  }
`;

export const GET_DATADASHBOARD_IMPORT_DATA = gql`
  query getDatadashboardImportData($countries: [String!]) {
    core_datadashboard_import(where: { country: { _in: $countries } }) {
      country
      data_source
      date
      unit
      value
    }
  }
`;

/* Refinery Dashboard */

export const GET_REFINERY_DASHBOARD_DATA = gql`
  query getDatadashboardRefineryData($countries: [String!]) {
    core_datadashboard_refinery(where: { country: { _in: $countries } }) {
      country
      data_source
      date
      unit
      value
    }
  }
`;

/* Storage Dashboard */

export const GET_STORAGE_DASHBOARD_DATA = gql`
  query getDatadashboardStorageData($countries: [String!]) {
    core_datadashboard_stocks(where: { country: { _in: $countries } }) {
      closing_stock
      country
      data_source
      date
      stock_change
      unit
    }
  }
`;

/*  */
export const GET_PRODUCTION_DASHBOARD = gql`
  query webdashboard_production_overviewtable($component_name: String, $component_version: Int) {
    core_web_datadashboard_production(
      where: { component_name: { _eq: $component_name }, component_version: { _eq: $component_version } }
    ) {
      json_data
    }
  }
`;

/*  */
export const GET_SEASONALITY_CHART_FOR_PRODUCTION_DASBOARD = gql`
  query webdashboard_production_seasonalitychart($component_name: String, $component_version: Int) {
    core_web_datadashboard_production(
      where: { component_name: { _eq: $component_name }, component_version: { _eq: $component_version } }
    ) {
      json_data
    }
  }
`;

/*  */
export const GET_TREND_LINE_CHART_FOR_PRODUCTION_DASHBOARD = gql`
  query webdashboard_production_trendchart($component_name: String, $component_version: Int) {
    core_web_datadashboard_production(
      where: { component_name: { _eq: $component_name }, component_version: { _eq: $component_version } }
    ) {
      json_data
    }
  }
`;

export const GET_IMPORT_EXPORT_DASHBOARD = gql`
  query webdashboard_importexport_overviewtable($component_name: String, $component_version: Int) {
    core_web_datadashboard_importexport(
      where: { component_name: { _eq: $component_name }, component_version: { _eq: $component_version } }
    ) {
      json_data
    }
  }
`;

/*  */
export const GET_SEASONALITY_CHART_FOR_IMPORT_EXPORT_DASBOARD = gql`
  query webdashboard_importexport_seasonalitychart($component_name: String, $component_version: Int) {
    core_web_datadashboard_importexport(
      where: { component_name: { _eq: $component_name }, component_version: { _eq: $component_version } }
    ) {
      json_data
    }
  }
`;

/*  */
export const GET_TREND_LINE_CHART_FOR_IMPORT_EXPORT_DASHBOARD = gql`
  query webdashboard_importexport_trendchart($component_name: String, $component_version: Int) {
    core_web_datadashboard_importexport(
      where: { component_name: { _eq: $component_name }, component_version: { _eq: $component_version } }
    ) {
      json_data
    }
  }
`;

export const GET_REFINERY_DASHBOARD = gql`
  query webdashboard_refinery_overviewtable($component_name: String, $component_version: Int) {
    core_web_datadashboard_refinery(
      where: { component_name: { _eq: $component_name }, component_version: { _eq: $component_version } }
    ) {
      json_data
    }
  }
`;

/*  */
export const GET_SEASONALITY_CHART_FOR_REFINERY_DASBOARD = gql`
  query webdashboard_refinery_seasonalitychart($component_name: String, $component_version: Int) {
    core_web_datadashboard_refinery(
      where: { component_name: { _eq: $component_name }, component_version: { _eq: $component_version } }
    ) {
      json_data
    }
  }
`;

/*  */
export const GET_TREND_LINE_CHART_FOR_REFINERY_DASHBOARD = gql`
  query webdashboard_refinery_trendchart($component_name: String, $component_version: Int) {
    core_web_datadashboard_refinery(
      where: { component_name: { _eq: $component_name }, component_version: { _eq: $component_version } }
    ) {
      json_data
    }
  }
`;

export const GET_STORAGE_DASHBOARD = gql`
  query webdashboard_storage_overviewtable($component_name: String, $component_version: Int) {
    core_web_datadashboard_storage(
      where: { component_name: { _eq: $component_name }, component_version: { _eq: $component_version } }
    ) {
      json_data
    }
  }
`;

/*  */
export const GET_SEASONALITY_CHART_FOR_STORAGE_DASBOARD = gql`
  query webdashboard_storage_seasonalitychart($component_name: String, $component_version: Int) {
    core_web_datadashboard_storage(
      where: { component_name: { _eq: $component_name }, component_version: { _eq: $component_version } }
    ) {
      json_data
    }
  }
`;

/*  */
export const GET_TREND_LINE_CHART_FOR_STORAGE_DASHBOARD = gql`
  query webdashboard_storage_trendchart($component_name: String, $component_version: Int) {
    core_web_datadashboard_storage(
      where: { component_name: { _eq: $component_name }, component_version: { _eq: $component_version } }
    ) {
      json_data
    }
  }
`;

//
export const EXPORT_IMPORT_DATA = gql`
  query MyQuery($country_list: [String!], $gte_date: timestamp, $lte_date: timestamp) {
    data_library_jodi_crude_oil_import(
      where: { country: { _in: $country_list }, date: { _gte: $gte_date, _lte: $lte_date } }
    ) {
      country
      date
      unit
      value
    }
  }
`;

//
export const EXPORT_EXPORT_DATA = gql`
  query MyQuery($country_list: [String!], $gte_date: timestamp, $lte_date: timestamp) {
    data_library_jodi_crude_oil_export(
      where: { country: { _in: $country_list }, date: { _gte: $gte_date, _lte: $lte_date } }
    ) {
      country
      date
      unit
      value
    }
  }
`;

//
export const EXPORT_PRODUCTION_DATA = gql`
  query MyQuery($country_list: [String!], $gte_date: timestamp, $lte_date: timestamp) {
    data_library_jodi_crude_oil_production(
      where: { country: { _in: $country_list }, date: { _gte: $gte_date, _lte: $lte_date } }
    ) {
      country
      date
      unit
      value
    }
  }
`;

//
export const EXPORT_CLOSING_STOCK_DATA = gql`
  query MyQuery($country_list: [String!], $gte_date: timestamp, $lte_date: timestamp) {
    data_library_jodi_crude_oil_closing_stock(
      where: { country: { _in: $country_list }, date: { _gte: $gte_date, _lte: $lte_date } }
    ) {
      country
      date
      unit
      value
    }
  }
`;

//
export const EXPORT_STOCK_CHANGE_DATA = gql`
  query MyQuery($country_list: [String!], $gte_date: timestamp, $lte_date: timestamp) {
    data_library_jodi_crude_oil_stock_change(
      where: { country: { _in: $country_list }, date: { _gte: $gte_date, _lte: $lte_date } }
    ) {
      country
      date
      unit
      value
    }
  }
`;

//
export const EXPORT_REFINERY_INTAKE_DATA = gql`
  query MyQuery($country_list: [String!], $gte_date: timestamp, $lte_date: timestamp) {
    data_library_jodi_crude_oil_refinery_intake(
      where: { country: { _in: $country_list }, date: { _gte: $gte_date, _lte: $lte_date } }
    ) {
      country
      date
      unit
      value
    }
  }
`;

// Custom DataDashboard Queries
export const MACROECONOMIC_INDICATOR_NAME = gql`
  query MacroeconomicIndicatorName {
    core_indicators(distinct_on: Category) {
      Category
    }
  }
`;

export const MACROECONOMIC_COUNTRY_NAME = gql`
  query MacroeconomicsCountryName {
    core_indicators(distinct_on: Country) {
      Country
    }
  }
`;

export const MACROECONOMIC_DATA_QUERY = gql`
  query MyQuery($categories: [String!], $countries: [String!]) {
    core_indicators(
      where: { Category: { _in: $categories }, Country: { _in: $countries } }
      order_by: { DateTime: asc }
    ) {
      Category
      Country
      date: DateTime
      value: Value
    }
  }
`;

export const PRICE_ACTION_QUERY = gql`
  query MyQuery($symbol_code: String) {
    core_historical(where: { symbolcode: { _eq: $symbol_code } }) {
      date
      close
      high
      low
      open
      symbolcode
    }
  }
`;

export const TECHNICAL_INDICATOR_QUERY = gql`
  query technicalIndicatorQuery($symbolid: Int) {
    core_technical_indicators(distinct_on: symbolid, where: { symbolid: { _eq: $symbolid } }) {
      indicator_name
    }
  }
`;

export const TEHNICAL_INDICATOR_VALUE_QUERY = gql`
  query technicalIndicatorValueQuery($symbolid: Int, $indicator_name: String) {
    core_technical_indicators(where: { symbolid: { _eq: $symbolid }, indicator_name: { _eq: $indicator_name } }) {
      indicator_name
      date
      symbolid
      value
    }
  }
`;

export const GET_COPILOT_SETTINGS = gql`
  query getCopilotSettings {
    core_web_coanalyst_settings {
      coanalyst_settings
    }
  }
`;
